export const issue_category = {
  state: {
    issue_categories: []
  },
  mutations: {
    updateIssueCategories: function(state, newList) {
      state.issue_categories = newList;
    }
  },
  getters: {
    getAllIssueCategories(state) {
      return state.issue_categories;
    },
    getIssueCategoryByUUID(state) {
      return function(uuid) {
        return state.issue_categories.find(function(a) {
          return (a.uuid === uuid)
        })
      }
    }
  }
}